import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Container, Card, Alert } from 'react-bootstrap';

const AuthDebug = () => {
  const { auth, isAuthenticated, hasRole } = useAuth();
  
  return (
    <Container className="mt-4">
      <Card>
        <Card.Header>Authentication Debug Information</Card.Header>
        <Card.Body>
          <pre style={{ maxHeight: '400px', overflow: 'auto' }}>
            {JSON.stringify({
              isAuthenticated,
              hasAdminRole: auth?.user?.role === 'ADMIN',
              hasRoleCheck: hasRole(['ADMIN']),
              user: auth?.user,
              token: auth?.token ? 'Token exists' : 'No token',
            }, null, 2)}
          </pre>
          
          {auth?.user?.role !== 'ADMIN' && (
            <Alert variant="danger">
              Your role is {auth?.user?.role}, not ADMIN. This is why you can't access admin pages.
            </Alert>
          )}
          
          {!isAuthenticated && (
            <Alert variant="danger">
              You are not authenticated. Please log in.
            </Alert>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default AuthDebug;
